import React from 'react';

const TrustExpertsSection = ({ themeData }: any) => {
  return (
    <>
      {' '}
      <section className="priority-section">
        <div className="section-title">
          <h2
            style={{
              color: `#${themeData?.theme_4?.home?.section_2?.h2color}`,
            }}
          >
            {themeData?.theme_4?.home?.section_2?.title}
          </h2>
          <p
            style={{
              color: `#${themeData?.theme_4?.home?.section_2?.paracolor}`,
            }}
          >
            {themeData?.theme_4?.home?.section_2?.paragraph}
          </p>
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-4">
              <div className="priority-card-img">
                <img
                  src={themeData?.theme_4?.home?.section_2?.first_card_image}
                  alt=""
                />
                <span className="priority-card-img-overlay">
                  <p>{themeData?.theme_4?.home?.section_2?.image_title}</p>
                </span>
              </div>
            </div>
            <div className="col-md-8">
              <div className="row">
                {themeData?.theme_4?.home?.section_2?.card_section?.collection.map(
                  (item: any) => {
                    return (
                      <>
                        <div className="col-md-6">
                          <div className="priority-card">
                            <span className="priority-card-icon priority-card-iconico">
                              <img src={item.icon} alt="" />
                            </span>
                            <h3
                              style={{
                                color: `#${themeData?.theme_4?.home?.section_2?.h3color}`,
                              }}
                            >
                              {item.collection_title}
                            </h3>
                            <p
                              style={{
                                color: `#${themeData?.theme_4?.home?.section_2?.paracolor}`,
                              }}
                            >
                              {item.collection_paragraph}
                            </p>
                          </div>
                        </div>
                      </>
                    );
                  }
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TrustExpertsSection;
